import { Req } from "@larner.dev/req";

export const cmsRequest = new Req(import.meta.env.VITE_CMS_API_URL!);
cmsRequest.headers = {
  Accept: "application/json",
  "Content-Type": "application/json",
  Authorization: `Bearer ${import.meta.env.VITE_CMS_API_TOKEN}`,
};
cmsRequest.debug = !!import.meta.env.VITE_REQUEST_DEBUG;
